import { FC, ReactElement } from 'react';
import { Td } from '@chakra-ui/react';
import { Flex, FlexProps } from '@chakra-ui/react';
export interface CbTableCellElementProps extends FlexProps {
  borderColor?: string;
  element: ReactElement;
  isBold?: boolean;
  isCentered?: boolean;
}
export const CbTableCellElement: FC<CbTableCellElementProps> = ({
  borderColor,
  element,
  isBold,
  isCentered,
  ...props
}) => {
  const fontWeight = isBold ? 'bold' : 'normal';
  const justifyContent = isCentered ? 'center' : 'left';
  return <Td borderRight={borderColor ? '1px solid' : undefined} borderRightColor={borderColor} fontWeight={fontWeight} borderTop="none" borderBottom="none" textAlign="left" maxWidth={48} paddingY={2} paddingX={0} data-sentry-element="Td" data-sentry-component="CbTableCellElement" data-sentry-source-file="CbTableCellElement.tsx">
      <Flex paddingY={6} paddingX={10} alignItems="center" justifyContent={justifyContent} {...props} data-sentry-element="Flex" data-sentry-source-file="CbTableCellElement.tsx">
        {element}
      </Flex>
    </Td>;
};